import React from "react";
import { Link } from "react-router-dom";
import ConsignorTotals from "./ConsignorTotals";

// Landing page for a signed-in consignor: totals for the open sale, how the
// portal works, and the key dates. Laid out in two columns so it fits a
// laptop screen without scrolling.
export default function Landing({ items }) {
  return (
    <div className="landing">
      <ConsignorTotals items={items} />

      <div className="columns is-variable is-5">
        <div className="column is-flex is-flex-direction-column is-justify-content-center">
          <h2 className="title is-5 mb-3">
            Welcome to the Waitsfield Elementary Ski &amp; Skate Sale Consignment
            Dashboard!
          </h2>
          <p className="has-text-weight-semibold mb-1">How it works:</p>
          <ol className="how-it-works" aria-label="How it works">
            <li>
              Add every item you want to sell on the{" "}
              <Link to="/dashboard/inventory/add">Add Inventory</Link> tab.
            </li>
            <li>
              Check/update items you have registered on the{" "}
              <Link to="/dashboard/inventory">Current Inventory</Link> tab.
            </li>
          </ol>
        </div>

        <section className="column" aria-label="Key dates">
          <div className="box py-4">
            <p className="has-text-weight-bold has-text-centered is-size-5">
              Waitsfield Ski &amp; Skate Sale 2026
            </p>
            <p className="has-text-centered mb-3">11/14 • 9:00am–4:00pm</p>
            <ul className="key-dates">
              <li>
                <strong>Register ALL Consignment Items by 11/09 at 11pm</strong>
              </li>
              <li>
                Pick up Tags for your items at Waitsfield Elementary School from
                Wednesday to Friday <strong>(11/11-13)</strong>
              </li>
              <li>
                Drop off all Pre-registered Consignment items at Waitsfield
                Elementary on <strong>Friday 11/13 from 4pm to 7pm</strong>
              </li>
              <li>
                Pick up any Unsold Consignment Items on{" "}
                <strong>11/14 between 3:45 and 4:15pm</strong>.{" "}
                <strong>This is the ONLY opportunity to pick up unsold gear.</strong>{" "}
                Any unsold items not picked up by 4:15 on Saturday 11/14 will NOT
                be retrievable.
              </li>
            </ul>
          </div>
        </section>
      </div>

      <p className="has-text-centered">
        <Link to="/dashboard/faqs" className="button is-link is-light">
          FAQs
        </Link>
      </p>
    </div>
  );
}
